import {productCategories} from "../Data/ProductCategories"

const IconCard = () => {
    return (
      <div className="container  m-auto w-4/5 py-5">
        <div className="row">
            <div className='titleCard text-center'>
                <h5 className="text-[30px]">Why Choose Us</h5>
                <p className="text-[20px] my-3">Why choosing the right partner for your needs is crucial</p>
            </div>
            <ul className="iconCard grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {productCategories.map((item,id)=>(
                    <li key={id} className="my-5">
                        <div className="IconIage my-3">
                             <img src={item.image}/>
                        </div>
                      
                       <div className="itemTitle">
                          <h4 className="my-3 font-bold">{item.title}</h4>
                       </div>
                       <div className="itemDescription}">
                        <p>{item.description}</p>
                       </div>
                    </li>
                ))}
            </ul>
        </div>
      </div>
    )
}
export default IconCard ;